import { render, staticRenderFns } from "./Livestream.vue?vue&type=template&id=3108c23c&scoped=true&lang=pug&"
import script from "./Livestream.vue?vue&type=script&lang=ts&"
export * from "./Livestream.vue?vue&type=script&lang=ts&"
import style0 from "./Livestream.vue?vue&type=style&index=0&id=3108c23c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108c23c",
  null
  
)

export default component.exports